<template>
    <div>
        <Backer />
        
        <div class="fm-container">
            <div>
                <b-card-group deck>
                    <b-card
                        border-variant="success"
                        header="Tools"
                        header-bg-variant="success"
                        header-text-variant="white"
                        align="center"
                    >
                        <!-- <b-card-text v-if="userDetails.userrole=='admin'"><button v-on:click="$router.push('/tools/generate_pullist/')">
                            Generate Pullist
                        </button></b-card-text>

                        <b-card-text v-if="userDetails.userrole=='admin'"><button v-on:click="$router.push('/tools/pullists/')">
                            View Pullists
                        </button></b-card-text>

                        <b-card-text v-if="userDetails.userrole=='admin'"><button v-on:click="$router.push('/tools/generate_delivery_list/')">
                            Generate Delivery List
                        </button></b-card-text>

                        <b-card-text v-if="userDetails.userrole=='admin'"><button v-on:click="$router.push('/tools/delivery_lists/')">
                            View Delivery Lists
                        </button></b-card-text>

                        <b-card-text v-if="userDetails.userrole=='admin'"><button v-on:click="$router.push('/tools/delivery_zones/')">
                            Delivery Zones
                        </button></b-card-text> -->

                        <b-card-text>
                            <button v-on:click="$router.push('/inventory_products/trs/')">Transfers</button>
                        </b-card-text>

                        <b-card-text>
                            <button v-on:click="$router.push('/inventory_products/items_to_pull/')">Items To Pull</button>
                        </b-card-text>

                        <b-card-text>
                            <button v-on:click="$router.push('/inventory_products/items_to_pickdrop/')">Items To Pick/Drop</button>
                        </b-card-text>

                        <!-- <b-card-text>
                            <button v-on:click="$router.push('/tools/scanner/')">Scanner</button>
                        </b-card-text> -->
                    </b-card>
                
                </b-card-group>
            </div>
        </div>

    </div>
</template>

<script>
    import Backer from "@/components/globals/Backer"
    export default {
        name: "ManageTools",
        components: {Backer},
        data: function(){
            return {
                userDetails: {}
            }
        },
        methods: {},
        created: function(){
            this.userDetails = JSON.parse(localStorage.userDetails);
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/ManageTools.vue